export default __webpack_public_path__ + "static/media/s1.dee81346.png";